// extracted by mini-css-extract-plugin
export default {"root":"cuwYGulf","caption":"_2k7JWnv6","contactName":"_1d8f5r3e"};